import { useScrollAnim } from "../../hook/useScrollAnim";
import Logo1 from "../../../assets/img/projects/Maison_Marline/MM-hero.png";
import Logo2 from "../../../assets/img/projects/Maison_Marline/MM-Logo2.png";
import Logo3 from "../../../assets/img/projects/Maison_Marline/MM-Logo3.png";

export default function App() {
  const containerRef = useScrollAnim({
    selector: ".MM-Logo img",
    threshold: 0.3,
    once: true,
  });

  return (
    <div className="MM-Logo" ref={containerRef}>
      <img src={Logo2} alt="Logo 2" />
      <img src={Logo1} alt="Logo 1" />
      <img src={Logo3} alt="Logo 3" />
    </div>
  );
}
